// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3pvsS","title":"Header_title__7xACl","side":"Header_side__3ik-y"};